import React, { useRef, useState } from 'react';

import { PrismicRichText } from '@prismicio/react';
import Testimonial from '@repo/editor/src/components/Testimonial/Testimonial';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import { getMediaCdnUrl } from 'global/prismicUtils';

import {
  TestimonialList,
  IndicatorRow,
  Indicator,
  IndicatorContainer,
} from './styles';

const Testimonials = ({ slice }) => {
  const storedIndex = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const onScroll = (e) => {
    const { clientWidth, scrollWidth, scrollLeft } = e.target;
    const itemsQ = slice.items.length;
    const currentSlice = Math.abs(
      Math.round(scrollWidth / (scrollLeft + clientWidth - 30)) - itemsQ
    );
    if (currentSlice !== storedIndex.current) {
      setCurrentIndex(currentSlice);
    }
    storedIndex.current = currentSlice;
  };

  return (
    <ContentWrapper
      background={slice.primary.background || 'offWhiteToWhite'}
      className="testimonials"
      customWidth="1344px"
    >
      <TestimonialList
        bottomGap={slice.primary.bottomGap || '120px'}
        onScroll={onScroll}
      >
        {slice.items.map(({ image, name, title, text }) => (
          <Testimonial
            key={name}
            image={getMediaCdnUrl(image.url)}
            name={name}
            text={<PrismicRichText field={text} />}
            title={title}
          />
        ))}
      </TestimonialList>
      <IndicatorRow>
        <IndicatorContainer bottomGap={slice.primary.bottomGap || '120px'}>
          {slice.items.map((_, i) => {
            return <Indicator key={i} isCurrent={currentIndex === i} />;
          })}
        </IndicatorContainer>
      </IndicatorRow>
    </ContentWrapper>
  );
};

export default Testimonials;
